import type { FC } from "react";

import classNames from "classnames";

import { LoyaltyContactFormTextArea as UILoyaltyContactFormTextArea } from "@jti/ui/components/LoyaltyContactForm";

import type { loyaltyContactFormTextAreaInputs } from "./LoyaltyContactFormTextArea.builder";

import styles from "./LoyaltyContactFormTextArea.module.scss";

export type LoyaltyContactFormTextAreaProps = BuilderComponentProps<typeof loyaltyContactFormTextAreaInputs>;

export const LoyaltyContactFormTextArea: FC<LoyaltyContactFormTextAreaProps> = ({
  id,
  label,
  placeholder,
  validationErrorMessage,
  required,
  attributes,
}) => {
  return (
    <div {...attributes} className={classNames(styles.wrapper, attributes?.className)}>
      <UILoyaltyContactFormTextArea
        id={id}
        label={label}
        placeholder={placeholder}
        validationErrorMessage={validationErrorMessage}
        required={required}
      />
    </div>
  );
};
